"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformNetWire = void 0;
const TransformObject_1 = require("./TransformObject");
const TransformSchematicDrawing_1 = require("./TransformSchematicDrawing");
class TransformNetWire extends TransformObject_1.TransformObject {
    constructor(parent, from, to, draw, fromDimension, toDimension, strategyMetadata) {
        super(parent, {
            from,
            to,
            fromDimension,
            toDimension,
            strategyMetadata,
            debugDrawings: [],
        }, undefined, new Set());
        if (draw) {
            this._sharedData.draw = new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, draw, this);
        }
        const debugLayer = this.context?.options?.combobulationDebugLayerId;
        if (debugLayer !== undefined) {
            this._sharedData.debugDrawings.push(new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                layers: [debugLayer],
                drawing: { type: 'junction', position: from, radiusOverride: 0.5 },
            }), new TransformSchematicDrawing_1.TransformSchematicDrawing(parent, {
                layers: [debugLayer],
                drawing: { type: 'junction', position: to, radiusOverride: 0.5 },
            }));
        }
    }
    get creates() {
        return [...(this._sharedData.draw ? [this._sharedData.draw] : []), ...this._sharedData.debugDrawings];
    }
    compile() {
        const { from, to, fromDimension, toDimension, strategyMetadata } = this._sharedData;
        return this.parent.netCombobulator.addWire({
            from: { position: from, dimension: fromDimension ?? this.parent.netCombobulator.defaultDimension.name },
            to: { position: to, dimension: toDimension ?? this.parent.netCombobulator.defaultDimension.name },
            strategyMetadata,
        });
    }
}
exports.TransformNetWire = TransformNetWire;
//# sourceMappingURL=TransformNetWire.js.map